"use client";

import { logoutAction } from "@/app/(dashboard)/logout-actions";
import { Button } from "@/components/ui/button";
import { Box, Flex } from "@radix-ui/themes";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import { useTransition } from "react";

export function NoAccess() {
  const [isPending, startTransition] = useTransition();

  return (
    <Flex align="center" justify="center" style={{ minHeight: "100vh" }}>
      <Box style={{ maxWidth: 420, textAlign: "center" }}>
        <Flex direction="column" gap="4" align="center">
          <Heading size="5">Access not available</Heading>
          <Text color="gray" size="3">
            Your account doesn&apos;t have the correct access. Please reach out to customer support and we&apos;ll get
            you set up.
          </Text>
          <Button
            className="bg-orange-action hover:bg-orange-action/90 text-white border-orange-action"
            disabled={isPending}
            onClick={() => startTransition(() => logoutAction())}
          >
            {isPending ? "Logging out..." : "Log out"}
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
}
